import React from 'react';

import { Typography } from '@mui/material';

import PropTypes from 'prop-types';

import { MDialog } from 'common';
import { dialogContainerStyles } from 'common/dialog-explicit-confirmation/DialogExplicitConfirmation.styles';

const DialogUnsavedChanges = ({ leftButtonAction, rightButtonAction, onClose, open, ...props }) => {
  return (
    <MDialog
      header="Unsaved Changes"
      leftButtonAction={leftButtonAction}
      leftButtonText="Continue"
      onClose={onClose}
      open={open}
      rightButtonAction={rightButtonAction}
      rightButtonText="Keep Editing"
      slotProps={{ paper: { sx: dialogContainerStyles } }}
      {...props}
    >
      <Typography>Are you sure you want to leave this page? You have unsaved changes.</Typography>
    </MDialog>
  );
};

DialogUnsavedChanges.propTypes = {
  leftButtonAction: PropTypes.func,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  rightButtonAction: PropTypes.func,
};

DialogUnsavedChanges.defaultProps = {
  leftButtonAction: () => {},
  onClose: () => {},
  rightButtonAction: () => {},
};

export default DialogUnsavedChanges;
